// extracted by mini-css-extract-plugin
module.exports = {"deleted-filled":"deleted-filled_iwALD","dialogTitle":"dialogTitle_1-lCm","dialogText":"dialogText_2xQoD","exclaimation":"exclaimation_XLe9o"};